const STICKY_CONTAINER_SELECTOR = '.sticky-container'
const STICKY_SHADOW_CLASS = 'sticky-container--shadow'
const LIST_INFO_TITLE_SELECTOR = '.list-info__title'
const LIST_INFO_CONTAINER_SELECTOR = '.list-info'
const LIST_INFO_CONTAINER_EXPANDED_CLASS = 'expanded'
const LABEL_SHOW_MORE = 'Show More'
const LABEL_SHOW_LESS = 'Show Less'

const LocationDetail = {
  init: function (element) {
    const stickyContainers = element.querySelectorAll(STICKY_CONTAINER_SELECTOR)
    if (stickyContainers.length) {
      document.addEventListener('scroll', () => {
        Array.from(stickyContainers).forEach(item => {
          const rect = item.getBoundingClientRect()
          if (rect && !isNaN(rect.top)) {
            if (rect.top <= 0) {
              item.classList.add(STICKY_SHADOW_CLASS)
            } else {
              item.classList.remove(STICKY_SHADOW_CLASS)
            }
          }
        })
      })
    }
    const listInfoTitles = element.querySelectorAll(LIST_INFO_TITLE_SELECTOR)
    if (listInfoTitles.length) {
      // height will be updated to max height of all titles so they are all bottom aligned on desktop
      window.addEventListener('resize', () => {
        const titleHeights = []
        Array.from(listInfoTitles).forEach(item => {
          item.style.height = null
          titleHeights.push(item.offsetHeight)
        })
        if (window.innerWidth >= 768) {
          const tallestTitleHeight = Math.max(...titleHeights)
          Array.from(listInfoTitles).forEach(item => {
            item.style.height = tallestTitleHeight + 'px'
          })
        }
      })
      window.dispatchEvent(new Event('resize'))
    }
    const listInfoContainers = element.querySelectorAll(LIST_INFO_CONTAINER_SELECTOR)
    if (listInfoContainers.length) {
      // collapse list info lists on mobile
      Array.from(listInfoContainers).forEach(listInfoContainer => {
        const toggleElement = document.createElement('a')
        toggleElement.textContent = LABEL_SHOW_MORE
        toggleElement.className = 'list-info__toggle link link--external-small'
        toggleElement.setAttribute('href', '#')
        toggleElement.addEventListener('click', (e) => {
          e.preventDefault()
          if (listInfoContainer.classList.contains(LIST_INFO_CONTAINER_EXPANDED_CLASS)) {
            toggleElement.textContent = LABEL_SHOW_MORE
            listInfoContainer.classList.remove(LIST_INFO_CONTAINER_EXPANDED_CLASS)
          } else {
            toggleElement.textContent = LABEL_SHOW_LESS
            listInfoContainer.classList.add(LIST_INFO_CONTAINER_EXPANDED_CLASS)
          }
        }, false)
        listInfoContainer.appendChild(toggleElement)
      })
    }
  }
}

export default LocationDetail
